import QueryString from 'qs';

export type StatisticsDateRange = {
  from?: string;
  to?: string;
};

type ParsedFilterOption = {
  label?: string;
  value?: string;
};

const parseFilterOptions = (encodedValue: string): ParsedFilterOption[] => {
  return Object.entries(QueryString.parse(encodedValue)).map(
    ([, value]) => value as ParsedFilterOption
  );
};

export const parseStatisticsDateFilter = (
  searchParams: URLSearchParams,
  attributeName: string
): StatisticsDateRange | null => {
  const filterValue = searchParams.get(attributeName);

  if (!filterValue) {
    return null;
  }

  const firstSelectedRange = parseFilterOptions(filterValue)[0];

  if (!firstSelectedRange?.label) {
    return null;
  }

  const parsedRange = QueryString.parse(firstSelectedRange.label);
  const from =
    typeof parsedRange.from === 'string' ? parsedRange.from : undefined;
  const to = typeof parsedRange.to === 'string' ? parsedRange.to : undefined;

  if (!from && !to) {
    return null;
  }

  return { from, to };
};

export const getStatisticsYearDateRange = (
  year: number
): Required<StatisticsDateRange> => ({
  from: `${year}-01-01`,
  to: `${year}-12-31`,
});

export const encodeStatisticsDateFilter = (
  attributeName: string,
  dateRange: StatisticsDateRange,
  options?: {
    isHidden?: boolean;
  }
) => {
  return QueryString.stringify([
    {
      label: QueryString.stringify(dateRange),
      value: attributeName,
      type: 'DATE',
      ...(options?.isHidden ? { isHidden: 'true' } : {}),
    },
  ]);
};

export const matchStatisticsDateFilterYear = ({
  dateRange,
  years,
}: {
  dateRange: StatisticsDateRange | null;
  years: number[];
}) => {
  if (!dateRange) {
    return null;
  }

  return (
    years.find((year) => {
      const fullYearRange = getStatisticsYearDateRange(year);

      return (
        dateRange.from === fullYearRange.from &&
        dateRange.to === fullYearRange.to
      );
    }) || null
  );
};
